export default __webpack_public_path__ + "static/media/bg_blue_top.9eaefd35.png";